module.exports = __webpack_public_path__ + "img/big-icon-rising.71f11f78.svg";